export default __webpack_public_path__ + "static/media/ai-Icon-new.d3a768de.svg";